<template>
    <div class="background" style="height:100%">
      <div class="header">
        <img :src="logoPath" alt="" />
        <!-- <img src="/20220613/20220613041958908.png@/assets/logo.png" alt="" /> -->
        <p class="login-title">信息化资源管理平台</p>
      </div>
      <img src="../assets/background.png" fit="fill" style="position: absolute;z-index:1;width:100%;height:100%" />
      <img src="../assets/background2.png" fit="fill" style="position: absolute;z-index:1;width:100%;height:100%" />
      <div>
        <div class="login" style="position: absolute;z-index:100">
          <p>登录</p>
          <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
            <el-form-item label="账号" prop="username">
              <el-input v-model="form.username" placeholder="请输入账号" @keyup.enter.native="userNameEnter"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input v-model="form.password" ref="password" autocomplete="off" :type="passwordType" placeholder="请输入登录密码" @keyup.enter.native="login">
                <i v-if="showEye" v-preventReClick @click="showPassword" slot="suffix" class="iconfont eye">&#xe8ff;</i>
                <i v-else v-preventReClick @click="hiddenPassword" slot="suffix" class="iconfont eye">&#xe78f;</i>
              </el-input>
            </el-form-item>
          </el-form>
          <div class="remeber-password">
            <el-checkbox v-model="remeber">记住密码</el-checkbox>
          </div>
          <!-- <div class="button"> -->
          <el-button class="btn primary" type="primary" style="height:40px;width:100%" size="small" v-preventReClick @click="login">登录</el-button>
          <!-- </div> -->
        </div>
      </div>
      <!--  底部  -->
      <div class="el-login-footer">
        <span>{{config.HospitalName}}</span>
      </div>
    </div>
  </template>
  
  <script>
  import { GetCompanySetting } from "@/api";
  import { setLogoPath } from "@/utils/logo";
  
  export default {
    data () {
      return {
        form: {
          username: "",
          password: ""
        },
        showEye: true,
        remeber: false,
        passwordType: "password",
        rules: {
          // username: [{ required: true, message: "请输入账号", trigger: "blur" }],
          // password: [{ required: true, message: "请输入登录密码", trigger: "blur" }],
        },
        downloadUrl: `${config.FileUploadHost}/FileInfo/FileDownLoad`,
        config: config,
        logoPath: '',
        redirect: undefined
      };
    },
    watch: {
      $route: {
        handler: function (route) {
          this.redirect = route.query && route.query.redirect;
        },
        immediate: true
      }
    },
    methods: {
      login () {
        let params = {
          // password: this.$md5(this.form.password + "SRMD5"),
          password: this.encryptCBC(this.form.password),
          username: this.form.username,
        };
        this.$store
          .dispatch("Login", params)
          .then(
            () => {
              if (this.redirect) {
                sessionStorage.setItem("Path", this.redirect);
                this.$router.push({ path: this.redirect });
              }
              else {
                // 重置默认路由
                sessionStorage.setItem("AppId", 1);
                sessionStorage.setItem("Path", "/dashboard");
                this.$router.push("/").catch(() => { });
  
                // sessionStorage.removeItem("deptId")
                // sessionStorage.removeItem("warehouseId")
                this.mySessionStorage.removeDeptId()
                this.mySessionStorage.removeWarehouseId()
              }
            },
            (error) => {
              // this.loading = false;
              this.msgError(error.errorMessage || "登录失败，请稍后重试");
            }
          )
          .catch(() => {
            // this.loading = false;
            // this.getCode();
          });
      },
      // onPasswordFocus () {
      //   this.passwordType = "password";
      // },
      // onPasswordBlur () {
      //   this.passwordType = "text";
      // },
      showPassword () {
        this.showEye = false;
        this.passwordType = "text";
      },
      hiddenPassword () {
        // console.log("hiddenPassword")
        this.showEye = true;
        this.passwordType = "password";
      },
      getCompanySetting () {
        this.logoPath = require('@/assets/logo.png')
        setLogoPath('@/assets/logo.png')
        // sessionStorage.setItem("LogoPath", '../assets/logo.png');
        GetCompanySetting({})
          .then(res => {
            if (res.returnData && res.returnData.fileInfos && res.returnData.fileInfos.length > 0) {
              // console.log(this.$setting)
              this.getImgBase64String(res.returnData.fileInfos[0])
            }
          })
      },
      getImgBase64String (file) {
        if (file) {
          let fileId = file.id;
          this.$axios
            .get(`${this.downloadUrl}?fileId=${fileId}`, {
              responseType: 'arraybuffer'
            })
            .then((res) => {
              return (
                "data:image/png;base64," +
                btoa(
                  new Uint8Array(res.data).reduce(
                    (data, byte) => data + String.fromCharCode(byte),
                    ""
                  )
                )
              );
            })
            .then((data) => {
              if (data) {
                this.logoPath = data
                // setLogoPath(data)
                // sessionStorage.setItem("LogoPath", data);
                setLogoPath(data)
              }
              // else {
              //   this.logoPath = '../assets/logo.png'
              // }
            });
        }
      },
      userNameEnter () {
        this.$refs["password"].focus()
      }
    },
    created () {
      this.getCompanySetting()
    }
  };
  </script>
  
  <style lang="scss" scoped>
  body {
    // height: 100vh;
    .header {
      display: flex;
      height: 50px;
      background-color: white;
      img {
        width: 30px;
        height: 30px;
        padding: 10px;
      }
      p {
        width: 162px;
        height: 24px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #286ab4;
      }
    }
    .background {
      height: 100%;
      background: url(../assets/background.png) no-repeat;
      background-size: cover;
      .login {
        margin: 15vh 0 0 70%;
        width: 320px;
        height: 470px;
        background: #ffffff;
        box-shadow: 0px 6px 10px rgba(144, 147, 153, 0.5);
        opacity: 1;
        border-radius: 2px;
        padding: 25px 30px 0px;
        p {
          width: 40px;
          height: 26px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 0px;
          color: #286ab4;
        }
        .remeber-password {
          margin-bottom: 120px;
          color: #286ab4;
        }
      }
    }
    .eye {
      cursor: pointer; // 123
    }
  }
  </style>
  